import { DepartmentApi } from 'api/DepartmentApi';
import { backendApiClient } from 'container/backendApiClient';

export const departmentApi = new DepartmentApi(backendApiClient);
